import { render, staticRenderFns } from "./BaseSwitchInput.vue?vue&type=template&id=5e4adf9e"
import script from "./BaseSwitchInput.vue?vue&type=script&lang=js"
export * from "./BaseSwitchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports